<template>
	<AppHeader
		:logo="logo"
		:headerButton1="headerButton1"
		:headerButton2="headerButton2"
	/>

	<UiElement class="d-flex flex-column h-100 py-0" :settings="appearance.body.settings">
		<div class="flex-grow-1">
			<UiElement class="position-relative w-100" :settings="page.elements.block1.settings">
				<img
					class="d-block w-100"
					src="https://www.bifolcomatty.co.uk/wp-content/uploads/2019/08/placeholder-square.jpg"
					alt
				/>

				<div
					class="position-absolute bottom-0 start-0 d-flex align-items-center w-100 pt-5 pb-3 px-5"
					style="background: linear-gradient(0deg, rgba(0,0,0,.5) 0%, rgba(255,255,255,0) 100%); "
				>
					<UiText class="w-75 max-w-75 min-w-75" :settings="heading1">
						Product name
					</UiText>

					<UiText :settings="heading1">
						XX Kč
					</UiText>
				</div>
			</UiElement>

			<br>
			<br>

			<UiText :settings="text1">
				Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cupiditate ea, eaque fuga magni maiores maxime optio quasi voluptatem. At, sint?
			</UiText>

			<br>
			<br>

			<UiText :settings="text1">
				Alergeny: 1, 2, 4
			</UiText>
		</div>

		<UiElement class="position-sticky bottom-0 start-0 w-100 px-0" :settings="appearance.body.settings">
			<div class="d-flex justify-content-center mb-5">
				<UiButtonAmount
					:settings="general.elements.buttonAmount1.settings"
					:product="{ label: 'Test Product 1', id: 0, price: 100 }"
				>
					<template #default="{ count }">
						<UiText :settings="general.elements.heading4.settings">
							{{ count }}
						</UiText>
					</template>
				</UiButtonAmount>
			</div>

			<div class="d-flex gap-4">
				<UiButtonArrow :settings="button1" :body="page.appearance.body.settings" class="w-50">
					{{ translations?.chooseAnother || '{chooseAnother}' }}
				</UiButtonArrow>

				<router-link :to="`/${route.params.kioskId}/summary`" class="w-50 text-decoration-none">
					<UiButtonArrow :settings="button2" :body="page.appearance.body.settings" class="w-100" right>
						{{ translations?.total || '{total}' }} {{ total }} Kč
					</UiButtonArrow>
				</router-link>
			</div>
		</UiElement>
	</UiElement>
</template>

<script setup>
	import { computed } from 'vue';
	import { storeToRefs } from 'pinia';
	import { useThemeStore } from '@/stores/useThemeStore';
	import { useOrderStore } from '@/stores/useOrderStore';
	import UiElement from '@/components/UI/UiElement.vue';
	import UiButtonArrow from '@/components/UI/UiButtonArrow.vue';
	import UiButtonAmount from '@/components/UI/UiButtonAmount.vue';
	import UiText from '@/components/UI/UiText.vue';
	import { useRoute } from 'vue-router';
	import AppHeader from '@/components/AppHeader.vue';
	import { useInheritedSettings } from '@/composables/useInheritedSettings';
	import { useTranslationsStore } from '@/stores/useTranslationsStore';

	const route = useRoute();

	const themeStore = useThemeStore();
	const orderStore = useOrderStore();
	const translationsStore = useTranslationsStore();

	const { translations } = storeToRefs(translationsStore);
	const { theme } = storeToRefs(themeStore);
	const { total } = storeToRefs(orderStore);

	const general = computed(() => theme.value.general);
	const page = computed(() => theme.value.pages.productDetails);
	const appearance = computed(() => page.value.appearance);
	const elements = computed(() => page.value.elements);

	const heading1 = useInheritedSettings(computed(() => elements.value?.heading1));
	const text1 = useInheritedSettings(computed(() => elements.value?.text1));
	const button1 = useInheritedSettings(computed(() => elements.value?.button1));
	const button2 = useInheritedSettings(computed(() => elements.value?.button2));
	const logo = useInheritedSettings(computed(() => elements.value?.logo));
	const headerButton1 = useInheritedSettings(computed(() => elements.value?.headerButton1));
	const headerButton2 = useInheritedSettings(computed(() => elements.value?.headerButton2));
</script>